/**
 * "Has this come out?", asked in the reader's own calendar.
 *
 * The poller lives in UTC, rightly — a 6am cron has no reader whose timezone
 * could apply. The screens do have one, and judging "is it out?" against the
 * UTC day hands a reader in Sydney a thing at ten in the morning that their
 * own calendar said was out yesterday. Same rule as the poller's `hasPassed`
 * — the END of the date's range, so a book known only as "2026" is still not
 * out in January — but the day boundary is the device's.
 *
 * String comparison on ISO forms, deliberately: zero-padded 'YYYY-MM-DD'
 * sorts lexicographically, and building Dates here would reintroduce the
 * UTC-vs-local ambiguity this file exists to remove.
 */

import type { SlateDate } from '../../poller/types.js';

const pad = (n: number) => String(n).padStart(2, '0');

/** The device's own calendar date, as 'YYYY-MM-DD'. */
export function localToday(now: Date): string {
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

export function hasPassedLocally(d: SlateDate, now: Date): boolean {
  const today = localToday(now);
  switch (d.precision) {
    case 'year':
      return today.slice(0, 4) > d.value;
    case 'month':
      return today.slice(0, 7) > d.value;
    case 'day':
      return today > d.value;
  }
}
